import React from "react"

import { content } from "./style"

const ContentBox = ({ children }) => <div css={content}>{children}</div>

export default ContentBox
